export enum FeatureFlagConstant {
  CONFIG_TOBACCO = 'config_tobacco',
  CONFIG_GOOGLE_IMA = 'config_google_ima',
  CONFIG_PLAYER_RELOAD = 'config_player_reload',
  CONFIG_SPORTS = 'config_sports',
  FEATURE_ABR_CAPPING = 'feature_abr_capping',
  FEATURE_MIMETYPE_CHECK_ENABLED = 'feature_mimetype_check_enabled',
  CONFIG_PLAYER_OPTIONS_MOBILE = 'config_player_options_mobile',
  CONFIG_PLAYER_OPTIONS_DESKTOP = 'config_player_options_desktop',
  CONFIG_REGISTRATION_POPUP = 'config_regitration_popup',
  CONFIG_ADS = 'config_ads',
  CONFIG_PLAYER_LOGO = 'config_player_logo',
  CONFIG_PROFILES = 'config_profiles',
  LIVE_CHANNEL_GATING_FLAG = 'live_channel_gating_flag',
  LIVE_CHANNEL_WATERMARK = 'live_channel_watermark',
  ENABLE_NPAW_REPORTING = 'enable_npaw_reporting',
  CONFIG_DAI_FAILURE_FALLBACK = 'config_dai_failure_fallback',
  CONFIG_X_MINGAING = 'xmin_gating',
  ENABLE_SPORTS_LIVE_WATCH_HISTORY = 'enable_sports_live_watch_history',
  DISABLE_UPNEXT_RECO_API = 'disable_upnext_reco_api',
  LIVE_SPORTS_WATCH_HISTORY_HEARTBEAT = 'live_sports_watchHistory_heartbeat',
  ENABLE_CHROMECAST = 'enable_chromecast',
  ENABLE_WATCH_HISTORY_VOD = 'enable_watch_history_vod',
  ENABLE_WATCH_HISTORY_SPORTS_VOD = 'enable_watch_history_sports_vod'
}
